<template>
  <modal
    name="ticket-form"
    transition="pop-out"
    :classes="'modal fade show'"
    :height="modalHeight"
    :resizable="false"
    :pivot-y="0.05"
    @before-open="beforeOpen"
  >
    <div class="modal-dialog ui-block window-popup create-event">
      <a
        href="#"
        class="close icon-close"
        aria-label="Close"
        @click="$modal.hide('ticket-form')"
      >
        <app-icon
          name="olymp-close-icon"
          color="black"
          size="small"
        />
      </a>
      <div class="fl-msg" />

      <div class="ui-block-title">
        <h6 class="title">
          Ticket
        </h6>
      </div>

      <div class="ui-block-content">
        <form
          class="content"
          @submit.prevent="submitRow"
        >
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Title</strong></p>
              <input
                v-model="item.title"
                class="form-group label-floating"
              >
            </div>
          </div>

          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Rank</strong></p>
              <input
                v-model="item.rank"
                class="form-group label-floating"
              >
            </div>
          </div>

          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Status</strong></p>
              <select
                v-model="item.status"
                class="form-group has-bootstrap-select "
              >
                <option
                  v-for="option in statuses"
                  :key="option"
                  :value="option"
                >
                  {{ option.toUpperCase() }}
                </option>
              </select>
            </div>
          </div>


          <button
            class="btn btn-lg btn-breez full-width mt-4"
            type="submit"
            name="submit"
          >
            <span>{{ item.id ? 'Edit' : 'Add' }} Ticket</span>
          </button>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { EventBus } from '../../../event-bus.js'
import VModal from 'vue-js-modal';
import Vue from 'vue'
Vue.use(VModal, {dialog: true});

const MODAL_HEIGHT = 800

import AppIcon from "../../common-apps/common/AppIcon.vue"
// import ticketStore from "../../../store/modules/vocational/ticket";

export default {
  name: 'TicketForm',
  components: { AppIcon },
  data () {
    return {
      modalHeight: MODAL_HEIGHT,
      statuses: ['ON_GOING', 'ON_HOLD', 'COMPLETE', 'ACTIVE'],
      item: {
        title: '',
        status: 'ACTIVE',
        rank: 0,
      }
    }
  },
  created () {
    // if (!this.$store.hasModule('ticket')) {
    //   this.$store.registerModule('ticket', ticketStore)
    // }
    this.modalHeight = window.innerHeight < MODAL_HEIGHT
        ? MODAL_HEIGHT - 200
        : MODAL_HEIGHT

    EventBus.$on('close-modal', () => {
      this.$modal.hide('ticket-form')
    })
  },
  // beforeDestroy () {
  //   this.$store.unregisterModule('ticket')
  // },
  methods: {
    beforeOpen (event) {
      if (event.params.item) {
        this.item = event.params.item
      }
    },
    // eslint-disable-next-line
    submitRow: function() { // !!!! this messes up if I use arrow function
      const payload = this.item
      if (this.item.id) {
        this.$store.dispatch('ticket/edit', {payload, id: this.item.id})
      } else {
        this.$store.dispatch('ticket/add', payload)
      }
    }
  }
}
</script>
